import news from "./news";
import pages from "./pages";
import profile from "./profile";
import calendar from "./calendar";
import search from "./search";
import knowledgeBase from "./knowledgeBase";
import event from "./event";
import businessTrips from "./businessTrips"
import correspondences from "@/routers/portal/correspondences";
import drivers from "@/routers/portal/drivers";
import performanceGoals from "@/routers/portal/performance-goals";
import userPerformance from "@/routers/portal/userPerformance";
import positionLevel from "@/routers/portal/positionLevel";
import halls from "@/routers/portal/halls";
import vacations from "@/routers/portal/vacations";

const routers = [
  {
    path: '/',
    redirect: '/news',
    component: () => import('@/layouts/LayoutUser.vue'),
    children: [
      ...news,
      ...profile,
      ...calendar,
      ...search,
      ...knowledgeBase,
      ...pages,
      ...event,
      ...businessTrips,
      ...correspondences,
      ...drivers,
      ...performanceGoals,
      ...userPerformance,
      ...positionLevel,
      ...halls,
      ...vacations,
    ],
  },
]
export default routers
